import apiRequestType from "../../apiRequestType";
import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";

const postImage = (data) => {
  return apiRequestType(apiTypes.POST, apiConstants.SOCIAL.POST_POLL, data);
};

export default postImage;
